import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const EmptyState = () => (
  <div className="flex h-full items-center justify-center">
    <Typography variant="body-sm" color="secondary">
      {t("tiptap.no_results_found")}
    </Typography>
  </div>
);
